// Purchase Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get purchaseList from backend then update purchaseList in vuex store ***** //
export const updatePurchaseList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      ...payload.advancedSearch,
      is_filtered: payload.isFiltered
    }
  }

  try {
    const result = await Axios.get('fixed_asset_purchases_index', { params: params })
    const resultData = result.data.data
    let resultWithFooter = resultData.data
    resultWithFooter.footer = resultData.footer
    // commit('updatePurchaseList', result.data.data)
    commit('updatePurchaseList', resultWithFooter)

  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Purchase from backend ***** //
export const fetchPurchaseInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`fixed_asset_purchases_show/${payload}`)
    commit('fetchPurchaseInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseCount from backend ***** //
export const fetchUnClosedPurchaseCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unclosed_fixed_asset_purchase_count`)
    commit('fetchUnClosedPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch unClosedPurchaseCount from backend ***** //
export const fetchUnPaidPurchaseCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`unpaid_fixed_asset_purchase_count`)
    commit('fetchUnPaidPurchaseCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Close Purchase from backend ***** //
export const closePurchase = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`fixed_asset_purchases_close/${payload.id}`, {
      params: payload
    })
    helpers.ktNotify({
      type: 'success',
      text: 'Closed Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Open Purchase from backend ***** //
export const openPurchase = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`fixed_asset_purchases_unclose/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Opened Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Purchase  ***** //
export const addPurchase = async (ignored, payload = null) => {
  try {
    await Axios.post('fixed_asset_purchases_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Purchase  info ***** //
export const updatePurchaseInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`fixed_asset_purchases_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Purchase  ***** //
export const deletePurchase = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`fixed_asset_purchases_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
